import React from 'react';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ImageLink {
	image?: IImage;
	link?: ILink;
}

export interface IImageLinksProps {
	imageLinkGroup?: ImageLink[];
}

const ImageLinks: React.FC<IImageLinksProps> = ({ imageLinkGroup = [] }) => {
	return (
		<>
			{imageLinkGroup.length > 0 && (
				<ul>
					{imageLinkGroup.map((item, index) => (
						<li key={index}>
							{item?.link?.href && (
								<Button
									{...item.link}
									className="mega-menu-corporate__image-link"
								>
									{item?.image?.src && (
										<div>
											<Image {...item.image} />
										</div>
									)}
								</Button>
							)}
						</li>
					))}
				</ul>
			)}
		</>
	);
};

export default ImageLinks;
